module.exports = __webpack_public_path__ + "img/imagen3.3ffedfdf.png";